"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
const JSONbig = require('json-bigint')({ useNativeBigInt: true });
class PlanService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetchPlanList(fetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user/plan/admin/get_all?page=${fetchPayload.pageNumber}&limit=${fetchPayload.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const responseData = response.data.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error('Failed to fetch');
            }
        });
    }
    createPlan(planCreateData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user/plan/admin/create`;
                planCreateData = JSONbig.stringify(planCreateData);
                const response = yield axios_1.default.post(url, planCreateData, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
    updatePlan(planUpdateData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user/plan/admin/edit`;
                planUpdateData = JSONbig.stringify(planUpdateData);
                const response = yield axios_1.default.put(url, planUpdateData, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
    fetchPlanByApplication(fetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user/plan/admin/list?application_id=${fetchPayload.application_id}&page=${fetchPayload.pageNumber}&limit=${fetchPayload.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const responseData = response.data.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
    fetchPlanById(plan_id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}pay_per_user/plan/admin/getByID?plan_id=${plan_id}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error(err.response.data.message);
            }
        });
    }
}
exports.PlanService = PlanService;
